// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"485":"2fd82681","665":"b2e7af65","690":"8ed5438c"}[chunkId] + ".chunk.css";
};